import { JustpayPlaceEndpoint } from "@/views/loyalty/shared/endpoint_services/justpay-place-endpoint-service"

export class JustpayPlace {
    constructor () {
        this.justpayEndpointPlace = new JustpayPlaceEndpoint()
    }

    async getPlacesByCustomerId (customerId) {
        const places = await this.justpayEndpointPlace.getAllPlaces()
        return places ? places.filter(f => f.client == customerId) : []
    }

    async getPlace (placeId) {
        let place = {}
        place = await this.justpayEndpointPlace.getPlace(placeId)
        if (place ? place.length > 0 : false) {
            return place[0]
        }
        return null
    }
}
